import emojiRegex from 'emoji-regex';
import { get, isArray, toString, isObject, trim } from 'lodash';
import { format } from 'redux-form-validators';

export function cleanInput(value, removeEmoji = true) {
    if (!value) {
        return "";
    }
    if (removeEmoji === true) {
        const emojis = emojiRegex();
        return value.toString().replace(emojis, "");
    }
    return value;
}

export function cleanFormValues(values, beforeSend = false) {
    // Manipulate values if beforeSend is not false
    const newValues = beforeSend !== false ? beforeSend(values) : values;

    // Clone object
    let data = Object.assign({}, newValues);

    // Convert all empty string to null
    Object.entries(data).map(([k, v]) => {
        if (trim(v) === "") {
            data[k] = null;
            return true;
        }
        return false;
    })

    if (data.location && isObject(data.location)) {
        // Convert child to string && update the "" from location object as API doesn't support it
        Object.entries(data.location).map(([k, v]) => {
            if (trim(v) === "") {
                data["location"][k] = null;
                return true;
            }
            data["location"][k] = toString(v);
            return false;
        })
    }

    return data;
}

export function transformErrors(error) {
    let serverError = ["Error in contacting API. Please try in 10 minutes"];
    const errors = get(error, "response.data", false);
    if (isArray(errors)) {
        return errors
    }
    if (get(errors, 'message')) {
        return [get(errors, 'message')];
    }
    if (errors !== false) {
        // Convert error key to camelcase to sync with a field
        let newErrors = {};
        Object.entries(errors).map(([key, value]) => {
            const fieldName = get(key.split('-'), `1`, key);
            newErrors[fieldName] = isArray(value) ? value[0] : value;
            return true;
        })
        serverError = newErrors;
    }
    if (errors === false && process.env.REACT_APP_MODE !== "prod" && error.message) {
        serverError = [error.message];
    }
    return serverError;
}

export function nl2br(str, is_xhtml) {
    if (typeof str === 'undefined' || str === null) {
        return '';
    }
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
}

export const getPasswordValidationRegex = () => {
    return format({ with: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*\W).{7,}\S+$/, message: 'Should contains: [A-Z] [a-z] [0-9] [#?!@$%^&*-]' });
}

export const phoneNumberValidation = () => {
    return format({ with: /\s*(([+](\s?\d)([-\s]?\d)|0)?(\s?\d)([-\s]?\d){9}|[(](\s?\d)([-\s]?\d)+\s*[)]([-\s]?\d)+)\s*/, message: 'Invalid telephone no', allowBlank: true });
}